import { render, staticRenderFns } from "./inviteProxyApply.vue?vue&type=template&id=9badeb42&"
import script from "./inviteProxyApply.vue?vue&type=script&lang=js&"
export * from "./inviteProxyApply.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports